import { createIcon } from '@chakra-ui/icon'

export const FolderIcon = createIcon({
  viewBox: '0 0 20 20',
  path: (
    <g>
      <path
        d="M8.33268 3.33203H3.33268C2.41602 3.33203 1.67435 4.08203 1.67435 4.9987L1.66602 14.9987C1.66602 15.9154 2.41602 16.6654 3.33268 16.6654H16.666C17.5827 16.6654 18.3327 15.9154 18.3327 14.9987V6.66536C18.3327 5.7487 17.5827 4.9987 16.666 4.9987H9.99935L8.33268 3.33203Z"
        fill="#A0AEC0"
      />
    </g>
  ),
})
